export default __webpack_public_path__ + "static/media/ichack.a4691e3d.png";